<div class="page-layout simple fullwidth">

    <!-- HEADER -->
    <div class="header ross-navy-500 p-24" fxLayout="row" fxLayoutAlign="start center">
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24" fxLayout="column" fxLayoutAlign="center center">
        <img src="assets/img/logofta.svg" alt="brand" class="brand">
        <span class="main-text">
            Bienvenido al Sistema de Fiscalia Tributaria
        </span>
    </div>
    <!-- / CONTENT -->

</div>
